import { PermissionKey, UserRole } from './enums';
import { DomainError } from './errors/domain-error';

export const ROLE_PERMISSIONS: Record<UserRole, PermissionKey[]> = {
  [UserRole.CONSUMER]: [
    PermissionKey.CAN_CREATE_MEMBER_POST,
    PermissionKey.CAN_CREATE_ARTICLE,
    PermissionKey.CAN_DELETE_POST,
    PermissionKey.CAN_LIKE,
    PermissionKey.CAN_COMMENT,
    PermissionKey.CAN_BOOKMARK,
    PermissionKey.CAN_REPORT,
    PermissionKey.CAN_FOLLOW_USER,
    PermissionKey.CAN_FOLLOW_CATEGORY,
    PermissionKey.CAN_BLOCK,
    PermissionKey.CAN_MUTE,
    PermissionKey.CAN_MESSAGE,
  ],
  [UserRole.CREATOR]: [
    PermissionKey.CAN_CREATE_POST,
    PermissionKey.CAN_CREATE_MEMBER_POST,
    PermissionKey.CAN_CREATE_ARTICLE,
    PermissionKey.CAN_DELETE_POST,
    PermissionKey.CAN_LIKE,
    PermissionKey.CAN_COMMENT,
    PermissionKey.CAN_BOOKMARK,
    PermissionKey.CAN_REPORT,
    PermissionKey.CAN_FOLLOW_USER,
    PermissionKey.CAN_FOLLOW_CATEGORY,
    PermissionKey.CAN_BLOCK,
    PermissionKey.CAN_MUTE,
    PermissionKey.CAN_MESSAGE,
    PermissionKey.CAN_MANAGE_OWN_SUBSCRIPTION,
    PermissionKey.CAN_MANAGE_COMMUNITIES,
    PermissionKey.CAN_MANAGE_EVENTS,
    PermissionKey.CAN_MANAGE_AUDIENCE,
    PermissionKey.CAN_VIEW_CREATOR_ANALYTICS,
    PermissionKey.CAN_MANAGE_MARKETING,
    PermissionKey.CAN_SEND_MARKETING,
    PermissionKey.CAN_MANAGE_MARKETING_AUTOMATIONS,
    PermissionKey.CAN_MANAGE_GROWTH,
    PermissionKey.CAN_MANAGE_DOMAINS,
    PermissionKey.CAN_MANAGE_SERVICES,
  ],
  [UserRole.MODERATOR]: [
    PermissionKey.CAN_MODERATE_CONTENT,
    PermissionKey.CAN_BAN_USER,
    PermissionKey.CAN_VIEW_ANALYTICS,
  ],
  [UserRole.ADMIN]: [
    PermissionKey.CAN_CREATE_POST,
    PermissionKey.CAN_CREATE_ARTICLE,
    PermissionKey.CAN_DELETE_POST,
    PermissionKey.CAN_BAN_USER,
    PermissionKey.CAN_VIEW_ANALYTICS,
    PermissionKey.CAN_MANAGE_OWN_SUBSCRIPTION,
    PermissionKey.CAN_MANAGE_SUBSCRIPTIONS,
    PermissionKey.CAN_MODERATE_CONTENT,
    PermissionKey.CAN_ACCESS_ADMIN_TOOLS,
    PermissionKey.CAN_MANAGE_MAIL_TEMPLATES,
    PermissionKey.CAN_MANAGE_NOTIFICATIONS,
    PermissionKey.CAN_MANAGE_FEATURE_FLAGS,
  ],
};

export function getPermissionsForRole(role: UserRole): PermissionKey[] {
  return ROLE_PERMISSIONS[role] ?? [];
}

export function hasPermission(role: UserRole, permission: PermissionKey): boolean {
  return ROLE_PERMISSIONS[role]?.includes(permission) ?? false;
}

/** Single RBAC enforcement entry point for the platform. */
export function checkPermission(role: UserRole, permission: PermissionKey): void {
  if (!hasPermission(role, permission)) {
    throw new DomainError(`Permission denied: ${permission}`);
  }
}
